'use strict'

import React from 'react'

export default class Modal extends React.Component {
  classNames (classes) {
    return Object.keys(classes).map(key => {
      return classes[key] ? key : null
    }).join(' ')
  }

  render () {
    const {opened, title, content, onClose} = this.props

    const modalClassNames = this.classNames({
      'modal-wrapper': true,
      'modal--show': opened
    })

    return (
      <div className={modalClassNames}>
        <div className='modal-content'>
          <div className='modal-close' onClick={onClose}>
            &times;
          </div>
          <h2 className='modal-heading'>{title}</h2>
          <div>
            {content}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/modal.js